import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, Icon, InputUI } from '@fourthwall/components';
import { ArrowShortDownIcon } from '@fourthwall/icons';
import * as S from './AnalyticsSelectTool.styled';
export const AnalyticsSelectTool = ({ label, renderContent, icon }) => {
    const [isOpen, setOpen] = useState(false);
    const [containerWidth, setContainerWidth] = useState(0);
    const containerRef = useRef(null);
    useEffect(() => {
        const updateWidth = () => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.offsetWidth);
            }
        };
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, [label]);
    return (React.createElement(Dropdown, { isOpen: isOpen, content: React.createElement(S.Content, { minWidth: containerWidth }, renderContent({ close: () => setOpen(false) })), position: "bottom-start", maxWidth: 900, onClose: () => setOpen(false) },
        React.createElement(InputUI.Root, null,
            React.createElement(InputUI.Box, { "$size": "small", "$focused": isOpen },
                React.createElement(S.Container, { ref: containerRef, tabIndex: 0, onClick: () => setOpen((status) => !status) },
                    React.createElement("div", null, label),
                    React.createElement(S.Icon, null,
                        React.createElement(Icon, { component: icon || ArrowShortDownIcon, height: 16 })))))));
};
